// Вхід в меню користувача
import "../styles/UserMenuGuest.css";
import { useTranslation } from "react-i18next";

export default function UserMenuGuest({ onLogin }) {
  const { t } = useTranslation("guest");

  return (
    <div className="umGuest">
      <div className="umTitle">{t("title")}</div>

      <div className="umSub">
        {t("subtitle_line1")}
        <br />
        {t("subtitle_line2")}
      </div>

      <button className="umLoginBtn" onClick={onLogin}>
        {t("login_google")}
      </button>
    </div>
  );
}